import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  text = 'Cargando...',
  fullScreen = false
}) => {
  const loaderContent = (
    <div className={`loader-container ${fullScreen ? 'fullscreen' : ''}`}>
      <div className={`loader-wrapper ${size}`}>
        <div className="loader-spinner">
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <div className="loader-center">
            <span className="loader-logo">DNA</span>
          </div>
        </div>
        {text && <p className="loader-text">{text}</p>}
      </div>
    </div>
  );

  return loaderContent;
};

// Skeleton Loader para tablas y cards
interface SkeletonProps {
  variant?: 'text' | 'rectangular' | 'circular';
  width?: string | number;
  height?: string | number;
  count?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'rectangular',
  width = '100%',
  height = 20,
  count = 1
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`skeleton skeleton-${variant}`}
          style={{
            width: typeof width === 'number' ? `${width}px` : width,
            height: typeof height === 'number' ? `${height}px` : height
          }}
        />
      ))}
    </>
  );
};

// Table Skeleton
export const TableSkeleton: React.FC<{ rows?: number; cols?: number }> = ({
  rows = 5,
  cols = 5
}) => {
  return (
    <div className="table-skeleton">
      <div className="table-skeleton-header">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} height={40} />
        ))}
      </div>
      <div className="table-skeleton-body">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="table-skeleton-row">
            {Array.from({ length: cols }).map((_, colIndex) => (
              <Skeleton key={colIndex} height={50} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

// Card Skeleton
export const CardSkeleton: React.FC = () => {
  return (
    <div className="card-skeleton">
      <Skeleton height={24} width="60%" />
      <Skeleton height={40} width="80%" />
      <Skeleton height={16} width="40%" />
    </div>
  );
};

export default Loader;
